module.exports = __webpack_public_path__ + "b3bdb3de3635c99e9774b2199abea55a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/bookshelves/bookshelf-sports.png
// module id = 3200
// module chunks = 0